export const STATUS_REPLACED_PARAM = '{status}'
export const ACTION_REPLACED_PARAM = '{action}'
